import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useCoursesContext } from "../context/courses_context";
import StarRating from "../components/StarRating";
import { MdInfo } from "react-icons/md";
import { TbWorld } from "react-icons/tb";
import { FaShoppingCart } from "react-icons/fa";
import { RiClosedCaptioningFill } from "react-icons/ri";
import { BiCheck } from "react-icons/bi";
import { useCartContext } from "../context/cart_context";
import { course_images } from "../utils/images";
import UploadWidget from "../components/Upload";
import { WithContext as ReactTags } from "react-tag-input";
import { useAuth0 } from "@auth0/auth0-react";
import "react-notifications-component/dist/theme.css";
import { Store } from "react-notifications-component";

const KeyCodes = {
  comma: 188,
  enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];

const SingleCoursePage = () => {
  const { user, isLoading, isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const { id } = useParams();
  const { fetchingSingleCourse, single_course } = useCoursesContext();
  const { addToCart } = useCartContext();
  const [prerequisitesTags, setPrerequisitesTags] = React.useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/drop`, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => console.log(res));
    // Store.addNotification({
    //   title: "Wonderful!",
    //   message: "teodosii@react-notifications-component",
    //   type: "success",
    //   insert: "top",
    //   container: "top-right",
    //   animationIn: ["animate__animated", "animate__fadeIn"],
    //   animationOut: ["animate__animated", "animate__fadeOut"],
    //   dismiss: {
    //     duration: 5000,
    //     onScreen: true,
    //   },
    // });
  }, []);
  const handlePrerequisitesDelete = (i) => {
    setPrerequisitesTags(prerequisitesTags.filter((tag, index) => index !== i));
  };

  const handlePrerequisitesAddition = (tag) => {
    setPrerequisitesTags([...prerequisitesTags, tag]);
  };

  const [skillsTags, setSkillsTags] = React.useState([]);

  const handleSkillsDelete = (i) => {
    setSkillsTags(skillsTags.filter((tag, index) => index !== i));
  };

  const handleSkillsAddition = (tag) => {
    setSkillsTags([...skillsTags, tag]);
  };

  const [courseDetails, setCourseDetails] = useState({
    title: "",
    description:
      "Learn A-Z everything about Python, from the basics, to advanced topics like Python GUI, Python Data Analysis, and more!",
    prerequisites: [],
    skills: [],
    links: [],
    creator: [],
  });

  useEffect(() => {
    fetchingSingleCourse(id);
  }, []);

  useEffect(() => {
    console.log(courseDetails);
  }, [courseDetails]);

  const {
    id: courseID,
    category,
    image,
    course_name,
    description,
    rating_count,
    rating_star,
    students,
    creator,
    updated_date,
    lang,
    actual_price,
    discounted_price,
    what_you_will_learn: learnItems,
    content,
  } = single_course;

  if (!(user && user["email"].includes("faculty"))) {
    return navigate("/");
  }

  return (
    <SingleCourseWrapper>
      <div className="course-intro mx-auto sgrid">
        <div className="upload-course">
          <UploadWidget setCourseDetails={setCourseDetails} />
          {/* <img src={image} alt={course_name} /> */}
        </div>
        <div className="course-details">
          <div className="course-head">
            <h6>Course Title: </h6>
            <input name="course-title" type="text" className="my-input-box" />
          </div>
          <div className="course-body">
            <p className="course-para fs-18">description</p>
            <input
              name="course-description"
              type="text"
              style={{ fontSize: "2.2rem" }}
              className="my-input-box"
            />
          </div>
        </div>
      </div>
      <div className="course-full bg-white text-dark">
        <div className="course-learn mx-auto">
          <div className="course-sc-title">Any Prerequistes ?</div>
          <ReactTags
            tags={prerequisitesTags}
            delimiters={delimiters}
            handleDelete={handlePrerequisitesDelete}
            handleAddition={handlePrerequisitesAddition}
            inputFieldPosition="bottom"
          />
        </div>
        <div className="course-learn mx-auto">
          <div className="course-sc-title">Skills learned after completion</div>
          <ReactTags
            tags={skillsTags}
            delimiters={delimiters}
            handleDelete={handleSkillsDelete}
            handleAddition={handleSkillsAddition}
            inputFieldPosition="bottom"
          />
        </div>
        <div style={{ display: "grid", placeItems: "center" }}>
          <div
            className="submit-button"
            onClick={() => {
              return navigate("/");
            }}
          >
            UPLOAD COURSE
          </div>
        </div>
      </div>
    </SingleCourseWrapper>
  );
};
const SingleCourseWrapper = styled.div`
  background: var(--clr-dark);
  color: var(--clr-white);

  .course-intro {
    padding: 40px 16px;
    max-width: 992px;

    .course-details {
      padding-top: 20px;
    }

    .course-category {
      padding: 0px 8px;
      border-radius: 6px;
    }

    .course-head {
      font-size: 38px;
      line-height: 1.2;
      padding: 12px 0 0 0;
    }
    .course-para {
      padding: 12px 0;
    }
    .rating-star-val {
      margin-right: 7px;
      padding-bottom: 5px;
      color: var(--clr-orange);
    }
    .students-count {
      margin-left: 8px;
    }
    .rating-count {
      margin-left: 6px;
      color: #d097f6;
    }
    .course-info {
      li {
        margin-bottom: 2px;
        &:nth-child(2) {
          margin-top: 10px;
        }
      }
      .course-info-txt {
        text-transform: capitalize;
        margin-left: 8px;
        margin-bottom: 4px;
      }
    }
    .course-price {
      margin-top: 12px;
      .old-price {
        color: #eceb98;
        text-decoration: line-through;
        margin-left: 10px;
      }
    }
    .course-btn {
      margin-top: 16px;
      .add-to-cart-btn {
        padding: 12px 28px;
        span {
          margin-left: 12px;
        }
      }
    }

    @media screen and (min-width: 880px) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 40px;
      .course-details {
        padding-top: 0;
      }
      .course-img {
        order: 2;
      }
      .upload-course {
        border: 4px dashed #fefefe;
        height: 400px;
        display: grid;
        place-items: center;
      }
    }

    @media screen and (min-width: 1400px) {
      grid-template-columns: 60% 40%;
    }
  }

  .my-input-box {
    width: 100%;
    height: 40px;
    font-size: 2.4rem;
    padding: 0.2em;
  }
  .course-full {
    padding: 40px 16px;
    .course-sc-title {
      font-size: 22px;
      font-weight: 700;
      margin: 12px 0;
    }
    .course-learn {
      max-width: 992px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: 12px 28px 22px 28px;

      .course-learn-list {
        li {
          margin: 5px 0;
          display: flex;
          span {
            &:nth-child(1) {
              opacity: 0.95;
              margin-right: 12px;
            }
          }
        }

        @media screen and (min-width: 992px) {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }

    .tag-wrapper {
      padding: 0.5em;
    }

    .submit-button {
      cursor: pointer;
      margin-top: 1em;
      width: 200px;
      display: grid;
      place-items: center;
      height: 80px;
      outline: solid 1px red;
      border-radius: 1em;
      transition: all 0.2s ease-in;
      :hover {
        outline: solid 2px red;
        background: red;
        color: #fefefe;
      }
    }
    .course-content {
      max-width: 992px;
      margin-top: 30px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: 12px 28px 22px 28px;

      .course-content-list {
        li {
          background-color: #f7f9fa;
          padding: 12px 18px;
          border: 1px solid rgba(0, 0, 0, 0.2);
          margin-bottom: 10px;
          font-weight: 800;
          font-size: 15px;
        }
      }
    }
  }
`;

export default SingleCoursePage;
